import { ChevronLeft } from '@doist/icons/brand';
import { Box, Button, Container, Heading, Image } from '@doist/marketist';
import cn from 'clsx';
import css from './article-page-header.module.css';
import type { ContainerProps } from '@doist/marketist';
export type ArticlePageHeaderProps = {
  thumbnail: {
    src: string;
    alt?: string;
    backgroundColor?: string;
    accessoryView?: React.ReactNode;
    viewType: 'icon' | 'image';
  };
  title: string;
  description?: string;
  backButton: {
    text: string;
    href: string;
  };
  buttons?: React.ReactNode[];
  accessoryButtons?: React.ReactNode[];
  width?: ContainerProps['width'];
};
export function ArticlePageHeader({
  thumbnail,
  title,
  description,
  backButton,
  buttons = [],
  accessoryButtons = [],
  width = 'lg'
}: ArticlePageHeaderProps) {
  return <Container className={cn(css.articlePageHeader, css[width], 'md-mbe-24 mbe-48')} width={width} data-sentry-element="Container" data-sentry-component="ArticlePageHeader" data-sentry-source-file="article-page-header.tsx">
            <Box className={css.thumbnail} style={{
      backgroundColor: thumbnail.backgroundColor
    }} data-sentry-element="Box" data-sentry-source-file="article-page-header.tsx">
                {thumbnail.viewType === 'icon' ? <Image src={thumbnail.src} width={135} height={135} alt={thumbnail.alt ?? ''} priority /> : <Image src={thumbnail.src} fill alt={thumbnail.alt ?? ''} priority />}
                {thumbnail.accessoryView}
            </Box>
            <Box className={cn(css.navigation, 'md-mbe-0 mbe-8')} data-sentry-element="Box" data-sentry-source-file="article-page-header.tsx">
                <Button variant="tertiary" href={backButton.href} startIcon={ChevronLeft} bleed="inline" size="large" data-sentry-element="Button" data-sentry-source-file="article-page-header.tsx">
                    {backButton.text}
                </Button>
            </Box>
            <Box className={cn(css.content, 'md-mb-0 mb-24')} data-sentry-element="Box" data-sentry-source-file="article-page-header.tsx">
                <Heading level="1" size="major-lg" weight="semibold" data-sentry-element="Heading" data-sentry-source-file="article-page-header.tsx">
                    {title}
                </Heading>
                {description && <Heading level="2" className={css.colorSecondary} size="body-lg">
                        {description}
                    </Heading>}
            </Box>
            {buttons.length > 0 || accessoryButtons.length > 0 ? <Box className={css.actions}>
                    {buttons.length > 0 ? <Box key="actions-btns">{buttons}</Box> : null}
                    {accessoryButtons.length > 0 ? <Box key="accessory-btns" className={css.accessoryButtons}>
                            {accessoryButtons}
                        </Box> : null}
                </Box> : null}
        </Container>;
}